<template>
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_14454_209512)">
            <path
                d="M16 0C6.988 0 0 6.604 0 15.52C0 20.184 1.912 24.216 5.024 27C5.284 27.232 5.444 27.56 5.452 27.912L5.54 30.76C5.54641 30.9696 5.60419 31.1743 5.70827 31.3563C5.81234 31.5383 5.95953 31.692 6.13689 31.8037C6.31425 31.9155 6.51635 31.982 6.72544 31.9974C6.93452 32.0128 7.14418 31.9766 7.336 31.892L10.512 30.492C10.78 30.372 11.084 30.352 11.368 30.428C12.828 30.828 14.38 31.044 16 31.044C25.012 31.044 32 24.44 32 15.524C32 6.608 25.012 0 16 0Z"
                fill="url(#paint0_radial_14454_209512)"
            />
            <path
                d="M6.39202 20.0598L11.092 12.6038C11.2688 12.3231 11.5019 12.0821 11.7766 11.896C12.0512 11.7099 12.3614 11.5828 12.6877 11.5226C13.014 11.4625 13.3491 11.4706 13.6721 11.5466C13.995 11.6225 14.2987 11.7646 14.564 11.9638L18.304 14.7678C18.471 14.8928 18.6741 14.96 18.8827 14.9593C19.0912 14.9586 19.2939 14.89 19.46 14.7638L24.508 10.9318C25.18 10.4198 26.06 11.2278 25.612 11.9438L20.908 19.3958C20.7312 19.6765 20.4981 19.9175 20.2235 20.1036C19.9488 20.2897 19.6386 20.4168 19.3123 20.477C18.9861 20.5371 18.6509 20.529 18.3279 20.453C18.005 20.3771 17.7013 20.235 17.436 20.0358L13.696 17.2318C13.529 17.1068 13.3259 17.0396 13.1173 17.0403C12.9088 17.041 12.7061 17.1096 12.54 17.2358L7.49201 21.0678C6.82001 21.5798 5.94002 20.7758 6.39202 20.0598Z"
                fill="white"
            />
        </g>
        <defs>
            <radialGradient
                id="paint0_radial_14454_209512"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(5.36 32) scale(35.2 35.2)"
            >
                <stop stop-color="#0099FF" />
                <stop offset="0.6" stop-color="#A033FF" />
                <stop offset="0.9" stop-color="#FF5280" />
                <stop offset="1" stop-color="#FF7061" />
            </radialGradient>
            <clipPath id="clip0_14454_209512">
                <rect width="32" height="32" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: "FacebookMessengerIcon",
};
</script>
